const src = (name, light) => `/brand/${name}${light ? "-light" : ""}.png`;

export const LogoMark = ({ className = "h-12 w-auto", light = false }) => (
  <img src={src("logo-mark", light)} alt="" aria-hidden="true" className={className} />
);

export const Logo = ({ light = false, compact = false }) => (
  <img
    src={src("logo-stack", light)}
    alt="STYLE PEINTURE DÉCORATION"
    data-testid="brand-logo"
    className={`w-auto transition-[height] duration-500 ${compact ? "h-14 lg:h-[68px]" : "h-16 lg:h-[88px]"}`}
  />
);

export const LogoFull = ({ light = false, className = "w-64" }) => (
  <img src={src("logo-full", light)} alt="STYLE PEINTURE DÉCORATION — Couleurs, matières, vos envies" className={className} />
);
